import {
   getSitePages,
   getSitePageById,
   createSitePages,
   deleteSitePage,
   toggleVisibilitySitePage,
   restorePages,
   getSitePageDifferentAccess,
   publishDraftContent,
   updateSitePage,
   getPageSectionById,
   updatePageSectionById,
   deletePageSection,
   toggleVisibilityPageSection,
   restoreSection,
   getPageSections,
   getGlobalSettings,
   updateGlobalSettings,
   logoImageUpload,
   faviconImageUpload,
}  from 'admin/api/AuthApi';
import {
   fetchPagesRequest,
   fetchPagesCompleted,
   getPageByIdRequest,
   getPageByIdCompleted,
   createPageCompleted,
   deletePageCompleted,
   toggleVisibilityPageCompleted,
   fetchPageDifferentAccessCompleted,
   publishDraftContentRequest,
   updatePageCompleted,
   fetchSaveAsDraftRequest,
   updatePageSectionsCompleted,
   updateCurrentSectionCompleted,
   setCurrentPage,
   deleteSectionCompleted,
   toggleVisibilitySectionCompleted,
   stateUpdateAction,
   updateGlobalSettingsCompleted,
   setUpdateContentResources,
   setPrepearComponentForRender,
} from './actions';
import toast from 'common/utils/toast';
import randomstring from 'randomstring';
import { isEqual } from 'lodash';
import { fetchResources, initCategories } from 'admin/api/AuthApi';

import {
   CREATE_PAGE_SEGMENT_KEY,
   setDevaultIcon,
   DEFAULT_ACCESS,
   MENU_SEGMENT_KEY,
   PAGE_SEGMENT_KEY,
   SECTION_SEGMENT_KEY,
   addOrRemoveQueryParams,
   getGlobalSettings as getGlobalSettingsStates,
   getSegmentStates,
   INITIAL_NEW_PAGE,
} from 'admin/views/site-designer/data';
import QueryParams from 'admin/utils/QueryParams';


// const newPage = {
//    name: 'Untitled',
//    icon: 'home',
// }
const sectionsState = getSegmentStates();

const MENU_STATE = {
   currentSegment: sectionsState[MENU_SEGMENT_KEY],
   currentPage: {},
   reservCurrentPage: {},
   currentSectionUuid: null,
   rightSide: null,
}

export const fetchContentResources = () => {
   return async (dispatch) => {
      try {
         const [resourcesResponse, categoriesRespose] = await Promise.all([
            fetchResources(null, ['resources=cast_members,tags,collections,photoset_collections,video_collections']),
            initCategories(['count=all']),
         ]);
         dispatch(setUpdateContentResources({
            ...resourcesResponse.data,
            categories: categoriesRespose.data,
         }));
      } catch (error) {
      }
   };
};

//  Back operation
export const goBackOperation = (currentType) => {
   return async (dispatch, getState) => {
      switch (currentType) {
         case PAGE_SEGMENT_KEY:
         case CREATE_PAGE_SEGMENT_KEY:{
            dispatch(stateUpdateAction({
               currentSegment: sectionsState[MENU_SEGMENT_KEY],
               currentPage: {},
               reservCurrentPage: {},
               currentSectionUuid: null,
               rightSide: null,
            }));
            addOrRemoveQueryParams(PAGE_SEGMENT_KEY);
            break;
         }
         case SECTION_SEGMENT_KEY:{
            const { siteDesigner: { currentPage, currentSegment, previousState } } = getState();
            let globalSection = null;
            const globalSettingsStates = getGlobalSettingsStates();
            globalSection = globalSettingsStates.find(settings => settings.uuid === currentSegment.section_type);
            if(globalSection && !currentSegment.isPageParent){
               dispatch(stateUpdateAction({
                  ...previousState,
               }));
               addOrRemoveQueryParams(SECTION_SEGMENT_KEY, previousState.currentSectionUuid);
               if(previousState.currentSectionUuid){
                  dispatch(onPrepearComponentForRender(true, previousState.currentSectionUuid))
               }
            } else {
               dispatch(stateUpdateAction({
                  currentSegment: {
                     ...sectionsState[PAGE_SEGMENT_KEY],
                     ...currentPage,
                  },
                  currentSectionUuid: null,
               }));
               addOrRemoveQueryParams(SECTION_SEGMENT_KEY);
            }
            break;
         }

         default:
            break;
      }
   };
};

export const navigateByQueryParamsOperation  = (pageData = null, isInit) => {
   return async (dispatch, getState) => {
      const pageQueryParam = QueryParams.getParam(PAGE_SEGMENT_KEY);
      const sectionParam = QueryParams.getParam(SECTION_SEGMENT_KEY) || null;
      const newPage = QueryParams.getParam(CREATE_PAGE_SEGMENT_KEY) || null;
      if(sectionParam){
         let globalSection = null;
         const globalSettingsStates = getGlobalSettingsStates();
         globalSection = globalSettingsStates.find(settings => settings.uuid === sectionParam);
         if(globalSection){
            dispatch(onSelectGlobalSettingsOperation(globalSection, true));
            addOrRemoveQueryParams(PAGE_SEGMENT_KEY);
            addOrRemoveQueryParams(CREATE_PAGE_SEGMENT_KEY);

            if(isInit){
               dispatch(fetchPagesRequest(false))

            }
         } else {
            const selectedPage = pageData.find(page => page.uuid === pageQueryParam);
            if(selectedPage){
               dispatch(onPrepearComponentForRender(true, false));
               await dispatch(getPageByIdOperation(selectedPage.id, null, true));

               await dispatch(getPageSectionsOperation(selectedPage.uuid, (sections) => {
                  const section = sections[sectionParam];
                  if(section){
                     dispatch(onSelectPageSectionOperation(section, true))
                  } else {
                     dispatch(onSelectPageOperation(selectedPage, true));
                     addOrRemoveQueryParams(SECTION_SEGMENT_KEY);
                  }
               }, { leftSideFetching: false }));

            } else {
               if(isInit){
                  dispatch(fetchPagesRequest(false))

               }
               addOrRemoveQueryParams(PAGE_SEGMENT_KEY);
               addOrRemoveQueryParams(SECTION_SEGMENT_KEY);
            }
         }
      } else if(pageQueryParam){
         const selectedPage = pageData.find(page => page.uuid === pageQueryParam);
         if(selectedPage){
            await dispatch(onSelectPageOperation(selectedPage, true));
         } else {
            if(isInit){
               dispatch(fetchPagesRequest(false))

            }
            addOrRemoveQueryParams(PAGE_SEGMENT_KEY);
         }
      } else if(newPage){
         dispatch(onClickAddNewPageOperation(true));
         if(isInit){
            dispatch(fetchPagesRequest(false))

         }
      }  else {
         dispatch(stateUpdateAction({
            ...MENU_STATE,
         }));
         if(isInit){
            dispatch(fetchPagesRequest(false))
         }
      }
      if(isInit){
         // dispatch(fetchPagesRequest(false))

      }
   }
}
export const getPagesOperation = () => {
   return async (dispatch) => {
      dispatch(fetchPagesRequest(true))
      try {
         const [pages, globalSettings] = await Promise.all([getSitePages(), getGlobalSettings()])
         const pageData = pages.data;
         const globalSettingsData = globalSettings.data;
         dispatch(fetchPagesCompleted(pageData, globalSettingsData))
         dispatch(fetchContentResources());
         dispatch(navigateByQueryParamsOperation(pageData, true));
         // dispatch(fetchPagesRequest(false))
      } catch (error) {
         dispatch(fetchPagesRequest(false))
      }
   };
};
//  Fetch page by id
export const getPageByIdOperation = (id, callBack, leftFetching = false) => {
   return async (dispatch) => {
      dispatch(getPageByIdRequest(true))
      try {
         const { data } = await getSitePageById(id);
         dispatch(getPageByIdCompleted(data, leftFetching))
         if(callBack){
            callBack(data)
         }
      } catch (error) {
         dispatch(getPageByIdRequest(false))
      }
   };
};
//  Fetch page sections uuid
export const getPageSectionsOperation = (uuid, callBack, anyState = {}) => {
   return async (dispatch) => {
      dispatch(stateUpdateAction({
         rightSideFetching: true,
      }))
      try {
         const { data } = await getPageSections(uuid);
         dispatch(stateUpdateAction({
            pageSections: data,
            reservPageSections: data,
            rightSideFetching: false,
            ...anyState,
         }))
         if(callBack){
            callBack(data)
         }
      } catch (error) {
         dispatch(stateUpdateAction({
            rightSideFetching: false,
         }))
      }
   };
};

// Create new page
export const createSitePageOperation = (bodyPayload, succesCallBack) => {
   return async (dispatch) => {
      dispatch(fetchSaveAsDraftRequest(true));
      try {
         const { data } = await createSitePages(bodyPayload);
         dispatch(createPageCompleted(data));
         if(succesCallBack){
            succesCallBack(data);
         }
         toast.success('Your page have been create!');

      } catch (error) {
         console.log(error)
         dispatch(fetchSaveAsDraftRequest(false));
      }
   };
};
export const updatePageOperation = (id, bodyPayload, succesCallBack) => {
   return async (dispatch) => {
      dispatch(fetchSaveAsDraftRequest(true));
      try {
         await updateSitePage(id, bodyPayload);
         dispatch(updatePageCompleted(id, {
            has_draft_content: true,
            ...bodyPayload,
         }));
         if(succesCallBack){
            succesCallBack();
         }
         toast.success('Your page have been updated!');
      } catch (error) {
         console.log(error)
         dispatch(fetchSaveAsDraftRequest(false));
      }
   };
};

// Delete new page
export const deleteSitePageOperation = (id, callback) => {
   return async (dispatch) => {
      // dispatch(getPageByIdRequest(true));
      try {
         await deleteSitePage(id);
         dispatch(deletePageCompleted(id, true));
         if(callback){
            callback();
         }
      } catch (error) {
         console.log(error)
         // dispatch(getPageByIdRequest(false))
      }
   };
};

// Delete new page
export const toggleVisibilitySitePageOperation = (id, callback) => {
   return async (dispatch) => {
      // dispatch(getPageByIdRequest(true));
      try {
         await toggleVisibilitySitePage(id);
         dispatch(toggleVisibilityPageCompleted(id));
         if(callback){
            callback();
         }
      } catch (error) {
         console.log(error)
         // dispatch(getPageByIdRequest(false))
      }
   };
};

// Restor new page
export const restoreSitePageOperation = (id, callback) => {
   return async (dispatch) => {
      // dispatch(getPageByIdRequest(true));
      try {
         await restorePages(id);
         dispatch(deletePageCompleted(id, false));
         if(callback){
            callback();
         }
         // dispatch(toggleVisibilityPageCompleted(id));

      } catch (error) {
         console.log(error)
         // dispatch(getPageByIdRequest(false))
      }
   };
};


// Publish all draft changes
export const publishDraftContentOperation = callback => {
   return async (dispatch) => {
      dispatch(publishDraftContentRequest(true));
      try {
         await publishDraftContent();
         dispatch(publishDraftContentRequest(false));
         dispatch(getPagesOperation());
         if(callback){
            callback()
         }
         toast.success('Your changes have been published!');

      } catch (error) {
         toast.error(('Something went wrong.'));
         dispatch(publishDraftContentRequest(false));
      }
   };
};

//  section
export const getSectionByIdOperation = (pageUuid, id, callback) => {
   return async (dispatch) => {
      dispatch(fetchPagesRequest(true))

      try {
         const { data } = await getPageSectionById(pageUuid, id);
         dispatch(updatePageSectionsCompleted(data.uuid, data));
         dispatch(updateCurrentSectionCompleted(data.uuid))
         dispatch(fetchPagesRequest(false))
         if(callback){
            callback()
         }
      } catch (error) {
         toast.error(('Something went wrong.'));
         dispatch(fetchPagesRequest(false))
      }
   };
};
export const updateSectionOperation = (page, sectionUuid, payload, callback) => {
   return async (dispatch) => {
      dispatch(fetchSaveAsDraftRequest(true));

      try {
         let newPage = null
         let uuid = page.uuid
         if(!uuid || uuid === CREATE_PAGE_SEGMENT_KEY){
            const { data } = await createSitePages({
               ...INITIAL_NEW_PAGE,
               ...DEFAULT_ACCESS,
            });
            uuid = data?.uuid
            newPage = data
            dispatch(createPageCompleted(data));
         }
         await updatePageSectionById(uuid, sectionUuid, payload);
         dispatch(setCurrentPage(payload, sectionUuid));
         if(callback){
            callback()
         }
         dispatch(fetchSaveAsDraftRequest(false));
         if(newPage){
            addOrRemoveQueryParams(CREATE_PAGE_SEGMENT_KEY);
            addOrRemoveQueryParams(SECTION_SEGMENT_KEY);

            dispatch(onSelectPageOperation(newPage));
         }
         toast.success('Your changes have been saved!');


      } catch (error) {
         toast.error(('Something went wrong.'));
         dispatch(fetchSaveAsDraftRequest(false));

      }
   };
};
export const prepearAddNewSection = (type, page, callback) => {
   return async (dispatch) => {
      const section = sectionsState?.[type];
      if(!section){
         console.log('add new section error 1')
         return
      }
      const uuid = randomstring.generate(32);
      let defaultValue = {
         type,
         is_active: true,
         uuid,
      }
      if(!section?.is_global_settings_section){
         defaultValue = {
            ...defaultValue,
            ...section.default_value,
         }
      } else {
         defaultValue = {
            ...defaultValue,
            tite: '---',
            description: '---',
         }
      }
      if(section?.is_global_settings_section){
         await dispatch(updateSectionOperation(page, uuid, defaultValue));
      }
      dispatch(updatePageSectionsCompleted(uuid, defaultValue));
      dispatch(updateCurrentSectionCompleted(uuid))

      if(callback){
         callback(defaultValue, uuid)
      }
   };
};

// Delete new page
export const deletePageSectionOperation = (pageUuId, id, callback, sectionUuid) => {
   return async (dispatch) => {
      // dispatch(getPageByIdRequest(true));
      try {
         await deletePageSection(pageUuId, id);
         dispatch(deleteSectionCompleted(id, true, sectionUuid));
         if(callback){
            callback();
         }
      } catch (error) {
         console.log(error)
         // dispatch(getPageByIdRequest(false))
      }
   };
};

// Delete new page
export const toggleVisibilityPageSectionOperation = (pageUuId, id, callback, sectionUuid) => {
   return async (dispatch) => {
      // dispatch(getPageByIdRequest(true));
      try {
         await toggleVisibilityPageSection(pageUuId, id);
         dispatch(toggleVisibilitySectionCompleted(id, sectionUuid));
         if(callback){
            callback();
         }
      } catch (error) {
         console.log(error)
         // dispatch(getPageByIdRequest(false))
      }
   };
};

// Restor new page
export const restorePageSectionOperation = (pageUuId, id, callback, sectionUuid) => {
   return async (dispatch) => {
      // dispatch(getPageByIdRequest(true));
      try {
         await restoreSection(pageUuId, id);
         dispatch(deleteSectionCompleted(id, false, sectionUuid));
         if(callback){
            callback();
         }
         // dispatch(toggleVisibilityPageCompleted(id));

      } catch (error) {
         console.log(error)
         // dispatch(getPageByIdRequest(false))
      }
   };
};

// Update global settings

const uploadSiteLogo = (site_long_name, data, font_name, color) => {
   return new Promise((resolve, reject) => {
      try {
         setDevaultIcon('main', site_long_name,  data.logo_type.text_data, async (res) => {
            const logoImageOptions = {
               type: 'default',
               fontName: font_name,
               color: color,
               width: res.width,
               text: site_long_name,
               fontSize: res.fontSize,
            };
            const uploadRes = await logoImageUpload(logoImageOptions);
            data = {
               ...data,
               logo_type: {
                  ...data.logo_type,
                  image_src: uploadRes.data.path,
                  text_data: {
                     ...data.logo_type.text_data,
                     logo_font_size: res.fontSize,
                     width: res.width,
                     text: site_long_name,
                  },
               },
            }
            resolve(data);
         })
      } catch (error) {
         reject(error)
      }
   });
}

const canUploadTextAppIconOrLogo = (currentType, data, reservGlobalSettings, type = 'app_icon_and_favicon') => {

   let key = 'logo_type';
   if('app_icon_and_favicon' === type)  key = 'app_icon_favicon_logo_type';
   const logoData = data?.[key] || {};
   if(type === currentType && logoData){
      const logoTypeData = reservGlobalSettings[currentType]?.[key] || {};
      const newLogoTypeData = logoData;
      if(
         'text' === logoData?.type
         && ('image' === logoTypeData.type || (!isEqual(logoTypeData.text_data, newLogoTypeData.text_data) && 'text' === logoTypeData.type))
      ){
         return true
      } else {
         return false
      }
   } else {
      return false
   }
}

function removeKey(obj, keyToRemove) {
   if(Array.isArray(obj)) {
      return obj.map(item => removeKey(item, keyToRemove));
   } else if(typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
         Object.entries(obj)
            .filter(([key]) => key !== keyToRemove)
            .map(([key, value]) => [key, removeKey(value, keyToRemove)])
      );
   }
   return obj;
}

export const updateGlobalSettingsOperation = (type, data, callback) => {
   return async (dispatch, getState) => {
      dispatch(fetchSaveAsDraftRequest(true));
      try {
         const { siteDesigner: { reservGlobalSettings }, common: { siteInfo: { site_long_name } } } = getState();
         const apiType = type.replaceAll('_', '-');
         let payload = structuredClone(data)
         // UPDLOAD CUSTOMIZE APP ICON AND FAVICON
         if(canUploadTextAppIconOrLogo(type, data, reservGlobalSettings, 'app_icon_and_favicon')){
            const iconImageOptions = {
               type: 'default',
               fontName: data.app_icon_favicon_logo_type.text_data.font_name,
               textColor: data.app_icon_favicon_logo_type.text_data.color,
               bgColor: data.app_icon_favicon_logo_type.text_data.background,
               dx: data.app_icon_favicon_logo_type.text_data.dx,
               dy: data.app_icon_favicon_logo_type.text_data.dy,
               strokeColor: data.app_icon_favicon_logo_type.text_data.stroke_color,
               text: data.app_icon_favicon_logo_type.text_data.text,
               fontSize: data.app_icon_favicon_logo_type.text_data.font_size,
            }
            const uploadRes = await faviconImageUpload(iconImageOptions);
            payload.app_icon_favicon_logo_type.image_src = uploadRes.data.path;
         }

         // UPDLOAD CUSTOMIZE SITE LOGO
         if(canUploadTextAppIconOrLogo(type, data, reservGlobalSettings, 'logo')){
            const newLogoTypeData = data?.logo_type;
            payload = await uploadSiteLogo(site_long_name, data, newLogoTypeData.text_data.font_name, newLogoTypeData.text_data.color);
         }
         payload = removeKey(payload, 'image_full_src')
         payload = removeKey(payload, 'video_full_src')
         await updateGlobalSettings(apiType, payload);
         dispatch(updateGlobalSettingsCompleted(type, data, true));
         dispatch(fetchSaveAsDraftRequest(false));
         if(callback){
            callback();
         }
         toast.success('Your changes have been saved');

      } catch (error) {
         console.log(error)
         toast.error(('Something went wrong.'));

         dispatch(fetchSaveAsDraftRequest(false));

      }
   };
};

// Update segment actions

export const onClickAddNewPageOperation = (isInited = false) => { // On click add new page buttons
   return async (dispatch) => {
      dispatch(stateUpdateAction({
         rightSide: 'mms_page_template',
         currentSegment: {
            ...sectionsState[CREATE_PAGE_SEGMENT_KEY],
         },
         pageSections: {},
      }))

      if(!isInited){
         addOrRemoveQueryParams(CREATE_PAGE_SEGMENT_KEY, 'new');
      }
      dispatch(onPrepearComponentForRender(true, true));
      try {
         const { data } = await getSitePageDifferentAccess();
         dispatch(fetchPageDifferentAccessCompleted({
            ...INITIAL_NEW_PAGE,
            ...data,

         }))
         dispatch(stateUpdateAction({
            savedData: {
               ...INITIAL_NEW_PAGE,
               ...DEFAULT_ACCESS,
            },
         }))
      } catch (error) {

      }

   };
};
export const onSelectGlobalSettingsOperation = (settings, isInited = false) => { // On click global settings options
   return async (dispatch, getState) => {
      const { siteDesigner: { currentSegment, currentSectionUuid, currentPage, pageSections, rightSide } } = getState()

      const uuid = settings.uuid;
      let previousState = {
         currentSegment,
         currentSectionUuid,
         currentPage,
         pageSections,
         rightSide,
      }
      let currentSegmentData = {
         ...sectionsState[settings.type],
         uuid: uuid,
         id: settings.id,
         ...settings,
         section_type: settings.type,
         type: 'section',
      }
      dispatch(stateUpdateAction({
         rightSide: currentSegmentData.right_side || 'mms_page_template',
         currentSegment: currentSegmentData,
         currentSectionUuid: uuid,
         savedData: {},
         currentPage: {},
         previousState,
      }));
      if(!isInited){
         addOrRemoveQueryParams(SECTION_SEGMENT_KEY, uuid);
      }
      dispatch(onPrepearComponentForRender(true, true));
   };
};

export const onSelectPageOperation = (page, isInited = false) => { // on select page
   return async (dispatch, getState) => {
      dispatch(stateUpdateAction({
         savedData: {},
         currentPage: {},
      }));
      if(page && (!page.is_system || page.is_homepage)){
         const { siteDesigner: { currentPage } } = getState();
         if(!isInited){
            addOrRemoveQueryParams(PAGE_SEGMENT_KEY, page.uuid);
            addOrRemoveQueryParams(CREATE_PAGE_SEGMENT_KEY)
            addOrRemoveQueryParams(SECTION_SEGMENT_KEY)
         }
         if(currentPage?.uuid !== page.uuid){
            if(isInited){
               await dispatch(getPageByIdOperation(page.id, null, true));
               await dispatch(getPageSectionsOperation(page.uuid, null, { leftSideFetching: false }));
            } else {
               dispatch(getPageByIdOperation(page.id, null));
               dispatch(getPageSectionsOperation(page.uuid, null));
            }
            dispatch(onPrepearComponentForRender(true, true));
         }
         dispatch(stateUpdateAction({
            rightSide: 'mms_page_template',
            currentSegment: {
               ...sectionsState[PAGE_SEGMENT_KEY],
               ...page,
            },
            currentSectionUuid: null,
            savedData: {},
         }));

      } else if(page) {
         if(!isInited){
            addOrRemoveQueryParams(PAGE_SEGMENT_KEY, page.uuid);
         }
         if(isInited){
            dispatch(fetchPagesRequest(false))
         }
         dispatch(stateUpdateAction({
            rightSide: page.name,
            currentSegment: {
               ...sectionsState[MENU_SEGMENT_KEY],
               uuid: MENU_SEGMENT_KEY,
            },
            currentPage: page,
            currentSectionUuid: null,
            savedData: {},
         }));
         if(!isInited){
            dispatch(onPrepearComponentForRender(true, true));
         }
      }
   };
};
export const onSelectPageSectionOperation = (section, isInited = false) => { // on select page
   return async (dispatch, getState) => {
      const uuid = section.uuid;
      let currentSegmentData = {
         ...sectionsState[section.type],
         uuid: uuid,
         id: section.id,
         ...section,
         section_type: section.type,
         type: 'section',
      }
      if(currentSegmentData.is_global_settings_section){
         currentSegmentData.uuid = currentSegmentData.section_type;
         currentSegmentData.isPageParent = true
      }
      dispatch(stateUpdateAction({
         rightSide: 'mms_page_template',
         currentSegment: currentSegmentData,
         currentSectionUuid: uuid,
      }));
      if(!isInited){
         addOrRemoveQueryParams(SECTION_SEGMENT_KEY, uuid);
      }
      dispatch(onPrepearComponentForRender(true, false, uuid));
   };
};


export const onPrepearComponentForRender = (left, right, uuid) => {
   return async (dispatch) => {
      dispatch(setPrepearComponentForRender({
         left,
         right,
      }))

      setTimeout(() => {
         dispatch(setPrepearComponentForRender({
            left: false,
            right: false,
         }))
         if(uuid){
            scrollIntoViewSection(uuid)
         }
      }, 500)
   };
};

const scrollIntoViewSection = (uuid) => {
   const section = document.querySelector(`#section_${ uuid }`)
   if(section){
      section.scrollIntoView({ block: 'center', behavior: 'auto' });
   }
}